export const getImageIdFromTags = (tags: Array<string>) => {
  let imageId = "";
  const imageTag = tags?.find((tag) => tag.startsWith("image"));
  if (imageTag) {
    imageId = imageTag.substring(imageTag.indexOf(":") + 1);
  }
  return imageId;
};

export const checkIsPollExpired = (dateString: string, daysNumber: number) => {
  const targetDate = new Date(dateString);
  const currentDate = new Date();

  const timeDiff = currentDate.getTime() - targetDate.getTime();

  const threeDaysInMillis = daysNumber * 24 * 60 * 60 * 1000;

  if (timeDiff >= threeDaysInMillis) {
    return true;
  } else {
    return false;
  }
};

export const timeUntilPollExpires = (
  dateString: string,
  daysNumber: number
): string => {
  const targetDate = new Date(dateString);
  const currentDate = new Date();

  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const millisecondsPerHour = 60 * 60 * 1000;

  const timePassed = currentDate.getTime() - targetDate.getTime();
  const remainingTime = daysNumber * millisecondsPerDay - timePassed;

  if (remainingTime <= 0) {
    return "0 days 0 hours";
  }

  const remainingDays = Math.floor(remainingTime / millisecondsPerDay);
  const remainingHours = Math.floor(
    (remainingTime % millisecondsPerDay) / millisecondsPerHour
  );

  return `${remainingDays} days ${remainingHours} hours`;
};
